
import React from 'react';
import { BrandCard, CardHeader, CardContent, CardTitle, CardDescription } from '@/components/ui/brand';
import { BrandText, BrandIcon } from '@/components/ui/brand';
import { Sparkles, Zap, MessageSquare, BarChart4, Brain } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      title: "Content Creation",
      description: "Generate engaging content for social media, blogs, and marketing materials that align with your brand.",
      icon: Sparkles
    },
    {
      title: "Quick Automation",
      description: "Automate routine tasks and workflows to save time and increase productivity.",
      icon: Zap
    },
    {
      title: "Smart Communication",
      description: "Engage with customers through AI-powered responses that match your company's voice.",
      icon: MessageSquare
    },
    {
      title: "Performance Analytics",
      description: "Track, measure, and improve your AI staff's performance through detailed analytics.",
      icon: BarChart4
    },
    {
      title: "Adaptive Learning",
      description: "Your AI staff learns and improves over time based on your feedback and interactions.",
      icon: Brain
    }
  ];

  return (
    <section className="py-16 px-4 bg-background">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <BrandText as="h2" size="3xl" weight="bold" className="mb-4">
            Features That Power Your Business
          </BrandText>
          <BrandText muted className="max-w-2xl mx-auto">
            Our AI staff members come equipped with powerful capabilities designed to transform your business operations.
          </BrandText>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <BrandCard 
              key={index} 
              animation="fade-in" 
              className="h-full transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <CardHeader>
                <div className="mb-4">
                  <BrandIcon icon={feature.icon} size="xl" color="primary" background />
                </div>
                <CardTitle>{feature.title}</CardTitle>
                <CardDescription>{feature.description}</CardDescription>
              </CardHeader>
              <CardContent>
                {/* Additional content could go here */}
              </CardContent>
            </BrandCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
